var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentPage',{attrs:{"back":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('content-page-title',[_vm._v(" Pro User Agreement ")])]},proxy:true}])},[_c('div',{staticClass:"pa-2 white rounded-lg"},[_c('ProEULA')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }